import { Component, OnInit, Input } from '@angular/core';
import { Item } from 'src/app/models/item.model';

@Component({
  selector: 'app-call-entry',
  templateUrl: './call-entry.component.html',
  styleUrls: ['./call-entry.component.scss']
})
export class CallEntryComponent implements OnInit {
  @Input() item: Item;
  @Input() operator: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
}
